export const isSessionValid = () => {
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10);
    if (!loginTime) return false;
  
    const sessionLimitMs = 24 * 60 * 60 * 1000; // 24 hours
    return Date.now() - loginTime <= sessionLimitMs;
  };
//   export const isSessionValid = () => {
//     const loginTime = parseInt(localStorage.getItem("loginTime"), 10);
//     if (!loginTime) return false;
  
//     const sessionLimitMs = 1 * 60 * 1000; // 1 minute
//     return Date.now() - loginTime <= sessionLimitMs;
//   };
  
  